import React from 'react'
import { Skeleton, Grid } from '@mui/material'

const EMobilityWallboxCardsSkeleton = (): JSX.Element => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
      <Grid item xs={12} sm={6} md={4} xl={3}>
        <Skeleton variant="rounded" height={120} />
      </Grid>
    </Grid>
  )
}

export default EMobilityWallboxCardsSkeleton
